export const formLanguageReloader = (tagName: string, pageName: string, language: string): void => {
  const detailComponent = document.getElementsByTagName(tagName);
  const page = document.getElementById(pageName);
  if (page && detailComponent?.length) {
    detailComponent[0].setAttribute('language', language);
    page.append(detailComponent[0]);
  }
};
